import { CupOffOutlineIcon } from './CupOffOutlineIcon';

/**
 * author: Simran
 * id C3BC4A94-7F95-4E12-A715-45830DEDA014
 * name cup-off-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cup-off-outline.svg
 * tags
 * - Food / Drink 
 */
export const GlassOffOutlineIcon = CupOffOutlineIcon;
export default GlassOffOutlineIcon